import { render, staticRenderFns } from "./resourceActive.vue?vue&type=template&id=51cbbec2"
import script from "./resourceActive.vue?vue&type=script&lang=js"
export * from "./resourceActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports